import { render, staticRenderFns } from "./RightSecond.vue?vue&type=template&id=52e3e5c9"
import script from "./RightSecond.vue?vue&type=script&lang=js"
export * from "./RightSecond.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports